import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { Reveal } from "@/components/Reveal";
import { imgSrc } from "@/lib/api";
import { CATEGORY_LABELS, fmtPrice } from "@/lib/constants";

export default function ProductCard({ product, index = 0 }) {
  return (
    <Reveal delay={(index % 4) * 0.08}>
      <Link
        to={`/prodotto/${product.id}`}
        data-testid={`product-card-${product.id}`}
        className="group block"
      >
        <div className="relative overflow-hidden bg-[#0a0a0a]">
          {product.image ? (
            <img
              src={imgSrc(product.image)}
              alt={product.name}
              loading="lazy"
              className="aspect-square w-full object-cover transition-transform duration-700 ease-out group-hover:scale-[1.06]"
            />
          ) : (
            <div className="aspect-square w-full bg-ivory" />
          )}
          {product.old_price && (
            <span className="absolute left-3 top-3 bg-gold px-2.5 py-1 text-[9px] font-semibold uppercase tracking-[0.25em] text-black" data-testid={`product-card-${product.id}-sale-badge`}>
              In offerta
            </span>
          )}
        </div>
        <div className="flex items-start justify-between gap-4 pt-4">
          <div className="min-w-0">
            <p className="text-[10px] uppercase tracking-[0.3em] text-[#A3A3A3]">
              {CATEGORY_LABELS[product.category] || product.category}
            </p>
            <h3 className="mt-1 font-serif text-lg leading-snug text-[#FAFAFA] transition-colors duration-300 group-hover:text-gold-pale">
              {product.name}
            </h3>
          </div>
          <div className="shrink-0 text-right">
            {product.old_price && (
              <p className="text-xs text-[#737373] line-through">€ {fmtPrice(product.old_price)}</p>
            )}
            <p className="font-medium text-gold" data-testid={`product-card-${product.id}-price`}>€ {fmtPrice(product.price)}</p>
          </div>
        </div>
        <span className="mt-3 inline-flex items-center gap-1.5 text-[10px] uppercase tracking-[0.28em] text-[#A3A3A3] transition-colors duration-300 group-hover:text-gold">
          Richiedi info <ArrowUpRight size={13} />
        </span>
      </Link>
    </Reveal>
  );
}
